export default __webpack_public_path__ + "static/media/title_th_sp.bf86ed71.png";